import api from './api';

export const getAvailableQuiz = async () => {
  const groupsList = await api.get('live-quiz');
  
  return groupsList.data;
}